<template>
  <div
    class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
    style="background-image: url('media/svg/login-bg.svg');background-repeat: no-repeat;background-size: cover;background-position: center;min-height: 100vh;"
  >
    <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
      <div class="text-center mb-10">
        <img src="media/svg/logo-login.svg" alt="Logo" class="h-70px" />
      </div>
      <div class="w-lg-600px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
        <Form
          class="form w-100"
          id="kt_login_idcard_form"
          @submit="onSubmitLogin"
          :validation-schema="loginSchema"
        >
          <div class="text-center mb-10">
            <h1 class="text-dark mb-3">เข้าสู่ระบบด้วยเลขบัตรประชาชน</h1>
          </div>

          <div class="fv-row mb-10">
            <label class="form-label fs-6 fw-bolder text-dark">เลขบัตรประชาชน</label>
            <Field
              class="form-control form-control-lg form-control-solid"
              type="text"
              name="idCard"
              autocomplete="off"
              maxlength="13"
              placeholder="กรอกเลขบัตรประชาชน 13 หลัก"
              @keypress="onlyNumbers"
            />
            <div class="fv-plugins-message-container">
              <div class="fv-help-block">
                <ErrorMessage name="idCard" />
              </div>
            </div>
          </div>

          <div class="text-center">
            <button
              type="submit"
              ref="submitButton"
              class="btn btn-lg w-100 mb-5"
              style="background: #323563;color: #ffffff"
            >
              <span class="indicator-label">เข้าสู่ระบบ</span>
              <span class="indicator-progress">
                Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
            <router-link
              to="/"
              class="btn btn-lg w-100 mb-5"
              style="color: #323563;border: 1px solid #323563;"
            >
              กลับสู่หน้าหลัก
            </router-link>
          </div>
        </Form>
      </div>
    </div>

    <div class="d-flex flex-center flex-column-auto p-10"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in-idcard",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const submitButton = ref<HTMLButtonElement | null>(null);

    const loginSchema = Yup.object().shape({
      idCard: Yup.string()
        .matches(/^\d{13}$/, "กรุณากรอกเลขบัตรประชาชน 13 หลักให้ถูกต้อง")
        .required("กรุณากรอกเลขบัตรประชาชน"),
    });

    const onSubmitLogin = async (values) => {
      if (submitButton.value) {
        submitButton.value.disabled = true;
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      await store.dispatch(Actions.LOGIN_THAI, { idCard: values.idCard });
      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      const adminRole = store.getters.currentUserAdminRole;

      if (!error) {
        localStorage.setItem("typeLogin", "idcard");
        if (adminRole == 4) {
          router.push({ name: "certificate-approve" });
        } else {
          router.push({ name: "my-exam" });
        }
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      submitButton.value!.disabled = false;
    };

    const onlyNumbers = (e: KeyboardEvent) => {
      if (!/\d/.test(e.key)) e.preventDefault();
    };

    return {
      onSubmitLogin,
      loginSchema,
      submitButton,
      onlyNumbers,
    };
  },
});
</script>
